import { useTranslations } from "adapters/i18n";
import type { NotifyFn } from "../../../userManagement.types";
import userService from "../../../userService";
import type { User } from "../userList.types";

type UseUserPasswordChangeProps = {
  onNotify: NotifyFn;
  toggleLoading: (isLoading: boolean) => void;
};
export function useUserPasswordChange({
  onNotify,
  toggleLoading,
}: UseUserPasswordChangeProps) {
  const { t } = useTranslations();

  const handleSendPasswordLink = async (user: User) => {
    try {
      toggleLoading(true);
      await userService.changePassword({ email: user.email });
      onNotify(t("user:send-password-link-success"), "success");
    } catch (err) {
      console.error(err);
      onNotify(t("user:send-password-link-error"), "error");
    } finally {
      toggleLoading(false);
    }
  };

  const handleCopyPasswordLink = async (user: User) => {
    try {
      toggleLoading(true);
      const response = await userService.changePassword({
        email: user.email,
        userId: user.id,
      });
      navigator.clipboard.writeText(response.url);
      onNotify(t("user:copy-password-link-success"), "success");
    } catch (err) {
      console.error(err);
      onNotify(t("user:copy-password-link-error"), "error");
    } finally {
      toggleLoading(false);
    }
  };

  return { handleCopyPasswordLink, handleSendPasswordLink };
}
